<template>
  <Modal extra-class="dea-modal--password dea-modal--no-footer" :visible="visible" @modal-close="$emit('modal-close')">
    <template v-if="user.parent_id" #title>
      {{
        passwordSaved
          ? "La tua password è stata modificata."
          : `Modifica la password di ${user.firstname} ${user.lastname}`
      }}
    </template>
    <template v-else #title>
      {{ passwordSaved ? "La tua password è stata modificata." : "Modifica la tua password" }}
    </template>
    <template #content>
      <template v-if="passwordSaved">
        <div>
          <Buttons class="dea-button--large" @click="$emit('modal-close')">
            Torna ai miei dati
          </Buttons>
        </div>
      </template>
      <template v-else>
        <div class="dea-modal__subtitle dea-heading--medium-s">Ricorda che deve essere almeno di 6 caratteri.</div>
        <div class="dea-modal__password-container">
          <InputText
            v-model="oldPassword"
            class="dea-modal__old-password"
            :type="passwordInputType.old"
            label="VECCHIA PASSWORD"
            @change="resetError()"
          ></InputText>
          <Links class="dea-modal__switch-password-link dea-links--large" @click="switchPwdType('old')">
            {{ switchPWdLabel.old }}
          </Links>
        </div>
        <div class="dea-modal__password-container">
          <InputText
            v-model="newPassword"
            class="dea-modal__new-password"
            :type="passwordInputType.new"
            label="NUOVA PASSWORD"
            @change="resetError()"
          ></InputText>
          <Links
            class="dea-modal__switch-password-link dea-links--large dea-links--pointer"
            @click="switchPwdType('new')"
          >
            {{ switchPWdLabel.new }}
          </Links>
        </div>
        <ErrorMessage v-if="showError"
          >La password non è corretta! Controlla di averla scritta senza errori e riprova</ErrorMessage
        >
        <Buttons class="dea-button--large" :disabled="checkPasswords" @click="changePassword()">
          Modifica password
        </Buttons>
      </template>
    </template>
  </Modal>
</template>

<script>
import * as Sentry from "@sentry/vue";
import Buttons from "@/components/elements/Buttons";
import ErrorMessage from "@/components/elements/ErrorMessage";
import InputText from "@/components/elements/InputText";
import Links from "@/components/elements/Links";
import Modal from "@/components/patterns/Modal";
import User from "../../../clients/user";
import showPassword from "~/components/myProfile/mixins/showPassword";

export default {
  name: "PasswordModal",
  components: { Buttons, ErrorMessage, InputText, Links, Modal },
  mixins: [showPassword],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      passwordSaved: false,
      showError: false,
    };
  },
  computed: {
    checkPasswords() {
      return !this.oldPassword || !this.newPassword || this.newPassword.length < 6;
    },
  },
  methods: {
    async changePassword() {
      const payload = {
        old_password: this.oldPassword,
        password: this.newPassword,
      };
      try {
        await User.modifyUserPassword(this.$root.config, this.user.id, payload);
        this.passwordSaved = true;
        setTimeout(() => {
          this.$emit("modal-close");
        }, 2000);
      } catch (e) {
        Sentry.captureException(e);
        this.showError = true;
      }
    },
    resetError() {
      this.showError = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$input-wrapper-width: 330px;

.dea-modal--password {
  .dea-modal__title-container {
    padding-bottom: $space-small;
  }

  .dea-modal__subtitle {
    margin-bottom: $space-large;
  }

  .dea-button {
    margin-bottom: $space-x-large;
    width: $input-wrapper-width;
  }

  .dea-input {
    margin-bottom: $space-x-small;
  }
}

.dea-modal {
  &__password-container {
    margin-bottom: $space-base;
  }

  &__switch-password-link {
    cursor: pointer;
  }
}
</style>
